<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title title="Ordem de compra">
      <template v-slot:before>
        <v-btn class="mb-1 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading" class="text-center">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && finalizacao" class="mt-3">
      <px-finalizacao-dados-basicos :compra-id="cotacaoId"
                                    :finalizacao="finalizacao"
                                    @movimentar="onMovimentar"/>
      <px-finalizacao-tabs :finalizacao="finalizacao"/>
      <px-finalizacao-mensagens-personalizadas v-if="checkMessages"
                                               :finalizacao="finalizacao"/>
      <px-finalizacao-produtos :finalizacao="finalizacao"/>

      <px-finalizacao-mensagem class="mt-3"
                               :compra="finalizacao"/>
    </div>
    <px-finalizacao-confirm v-model="showConfirm"
                            :request-id="cotacaoId"
                            :name="fornecedor"
                            @update="onUpdateConfirm"/>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto, SituacaoCompra, OrigemCompra } from 'px-business-components';
import eventsMixin from '@/mixins/events-mixin';
import VendaService from '../vendas-service';
import FinalizacaoDadosBasicos from './FinalizacaoDadosBasicos.vue';
import FinalizacaoProdutos from './FinalizacaoProdutos.vue';
import FinalizacaoConfirm from './FinalizacaoConfirm.vue';
import FinalizacaoMensagem from './FinalizacaoMensagem.vue';
import FinalizacaoTabs from './tabs/FinalizacaoTabs.vue';
import FinalizacaoMensagensPersonalizadas from './FinalizacaoMensagemPersonalizada.vue';

export default {
  mixins: [eventsMixin],
  data() {
    return {
      cotacaoId: this.$route.params.id,
      loading: false,
      showConfirm: false,
      finalizacao: null,
      breadcrumbs: [
        { text: 'Cotações' },
        { text: 'Vendas' },
      ],
    };
  },
  computed: {
    isRespondida() {
      return this.finalizacao && this.finalizacao.situacaoSolicitacaoResposta
          === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isCotacaoConjunta() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.COTACAO_CONJUNTA.key
        || this.finalizacao.origemCompra === OrigemCompra.keys.CATALOGO_COMPRA_CONJUNTA.key;
    },
    fornecedor() {
      if (!this.finalizacao) {
        return '';
      }
      return this.finalizacao.comprador.pessoa.nome;
    },
    checkMessages() {
      return this.finalizacao.mensagensPersonalizadas
        && this.finalizacao.mensagensPersonalizadas.length;
    },
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onMovimentar() {
      this.getFinalizacao();
    },
    getFinalizacao() {
      this.loading = true;
      return VendaService.getVenda(this.cotacaoId)
        .then((response) => {
          this.finalizacao = response.data;
          this.launchConfirmDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    launchConfirmDialog() {
      if (this.isCotacaoConjunta) {
        return;
      }
      if (this.finalizacao.status === 'COMPRA_RECEBIDA'
        || this.finalizacao.situacao !== SituacaoCompra.keys.APROVADA.key) {
        return;
      }
      this.showConfirm = true;
    },
    onUpdateConfirm() {
      this.finalizacao.status = 'COMPRA_RECEBIDA';
      this.showConfirm = false;
    },
  },
  created() {
    this.getFinalizacao();
    this.createEventAccess(this.eventsResource.COMPRA, { compra: this.cotacaoId });
  },
  components: {
    pxFinalizacaoDadosBasicos: FinalizacaoDadosBasicos,
    pxFinalizacaoProdutos: FinalizacaoProdutos,
    pxFinalizacaoConfirm: FinalizacaoConfirm,
    pxFinalizacaoMensagem: FinalizacaoMensagem,
    pxFinalizacaoTabs: FinalizacaoTabs,
    pxFinalizacaoMensagensPersonalizadas: FinalizacaoMensagensPersonalizadas,
  },
};
</script>
